import { render } from "./KeyMessages.vue?vue&type=template&id=0324047a&scoped=true"
import script from "./KeyMessages.vue?vue&type=script&lang=js"
export * from "./KeyMessages.vue?vue&type=script&lang=js"

import "./KeyMessages.vue?vue&type=style&index=0&id=0324047a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1463868861/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0324047a"]])

export default __exports__